import { hideOnMaxWidth } from "src/styles/mixins";
import styled from "styled-components";

export const SelectStyled = styled("select")(({ theme }) => ({
  padding: "6px 10px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "14px",
  backgroundColor: "white",
  color: "#333",
  ...hideOnMaxWidth(theme.screenMDMax),
}));
